import { call, put } from 'redux-saga/effects';
import * as supportLangsApi from '../../services/supportLangsApi';
import { commonLangs,state } from './dashboard';

export {state};

export const effects = {
  *getSupportLangs(action) {
    const response = yield call(supportLangsApi.getSupportLangs);
    return response
  }
};